
(function () {
  'use strict';

  function zdarzenie(nazwa, dane) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(nazwa, dane || {});
      }
    } catch (e) {}
  }

  var WZORZEC = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/;

  function odczytajDate(tekst) {
    var m = WZORZEC.exec((tekst || '').trim());
    if (!m) return null;
    var d = new Date(
      parseInt(m[1], 10),
      parseInt(m[2], 10) - 1,
      parseInt(m[3], 10),
      parseInt(m[4], 10),
      parseInt(m[5], 10),
      0
    );
    return isNaN(d.getTime()) ? null : d;
  }

  function czesc(wartosc, etykieta) {
    var box = document.createElement('span');
    box.className = 'bh-count__part';

    var liczba = document.createElement('span');
    liczba.className = 'bh-count__num';
    liczba.textContent = wartosc < 10 ? '0' + wartosc : String(wartosc);

    var opis = document.createElement('span');
    opis.className = 'bh-count__label';
    opis.textContent = etykieta;

    box.appendChild(liczba);
    box.appendChild(opis);
    return box;
  }

  function Licznik(korzen) {
    this.korzen = korzen;
    this.koniec = odczytajDate(korzen.getAttribute('data-bh-countdown'));
    this.etykiety = {
      lead: korzen.getAttribute('data-label-lead') || '',
      dni: korzen.getAttribute('data-label-days') || '',
      godziny: korzen.getAttribute('data-label-hours') || '',
      minuty: korzen.getAttribute('data-label-minutes') || '',
      sekundy: korzen.getAttribute('data-label-seconds') || ''
    };
    this.timer = null;

    if (!this.koniec || this.koniec.getTime() <= Date.now()) return;

    korzen.hidden = false;
    this.rysuj();
    var self = this;
    this.timer = window.setInterval(function () { self.rysuj(); }, 1000);
  }

  Licznik.prototype.rysuj = function () {
    var zostalo = this.koniec.getTime() - Date.now();
    if (zostalo <= 0) {
      this.stop();
      this.korzen.hidden = true;
      return;
    }

    var sekundy = Math.floor(zostalo / 1000);
    var dni = Math.floor(sekundy / 86400);
    var godziny = Math.floor((sekundy % 86400) / 3600);
    var minuty = Math.floor((sekundy % 3600) / 60);
    var sek = sekundy % 60;

    while (this.korzen.firstChild) this.korzen.removeChild(this.korzen.firstChild);

    if (this.etykiety.lead) {
      var lead = document.createElement('span');
      lead.className = 'bh-count__lead';
      lead.textContent = this.etykiety.lead;
      this.korzen.appendChild(lead);
    }

    var lista = document.createElement('span');
    lista.className = 'bh-count__parts';
    if (dni > 0) lista.appendChild(czesc(dni, this.etykiety.dni));
    lista.appendChild(czesc(godziny, this.etykiety.godziny));
    lista.appendChild(czesc(minuty, this.etykiety.minuty));
    lista.appendChild(czesc(sek, this.etykiety.sekundy));
    this.korzen.appendChild(lista);
  };

  Licznik.prototype.stop = function () {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  };

  var instancje = new WeakMap();

  function uruchom(zakres) {
    var korzenie = (zakres || document).querySelectorAll('[data-bh-countdown]');
    for (var i = 0; i < korzenie.length; i += 1) {
      if (instancje.has(korzenie[i])) continue;
      instancje.set(korzenie[i], new Licznik(korzenie[i]));
    }
  }

  function zatrzymaj(zakres) {
    var korzenie = (zakres || document).querySelectorAll('[data-bh-countdown]');
    for (var i = 0; i < korzenie.length; i += 1) {
      var instancja = instancje.get(korzenie[i]);
      if (instancja) {
        instancja.stop();
        instancje.delete(korzenie[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { uruchom(); });
  } else {
    uruchom();
  }

  if (!window.BramoweHomePromoKlik) {
    window.BramoweHomePromoKlik = true;
    document.addEventListener('click', function (ev) {
      var link = ev.target.closest ? ev.target.closest('[data-bh-promo-all]') : null;
      if (link) zdarzenie('bramowe_home_promo_all', {});
    });
  }
  document.addEventListener('shopify:section:load', function (ev) { uruchom(ev.target); });
  document.addEventListener('shopify:section:unload', function (ev) { zatrzymaj(ev.target); });
}());
